<template>
    <div v-if="!satisfied || alwaysShowIcon" class="gate-hint">
        <v-icon :color="satisfied ? 'white' : 'error'" size="18">{{ icon }}</v-icon>
        <span v-if="!satisfied && !iconOnly" class="gate-hint__text error--text">{{ message }}</span>
    </div>
</template>

<script>
    // Obecny indikator splneni/nesplneni nejake podminky (zatim jen "jsi ve
    // meste?" pro obchod - viz TradeHub.vue) - bila ikona kdyz podminka
    // plati, cervena ikona + hlaska kdyz ne. Neni napevno svazany s mestem,
    // aby slo pouzit i pro jine budouci podminky (jina ikona/hlaska).
    // iconOnly potlaci text (kompaktni odznak vedle titulku - misto na
    // hlasku tam neni), alwaysShowIcon drzi ikonu viditelnou i kdyz je
    // podminka splnena (trvaly stavovy indikator misto "zmiz, kdyz je OK").
    export default {
        name: 'GateHint',
        props: {
            satisfied: {type: Boolean, required: true},
            icon: {type: String, required: true},
            message: {type: String, required: true},
            alwaysShowIcon: {type: Boolean, default: false},
            iconOnly: {type: Boolean, default: false},
        },
    }
</script>

<style scoped>
.gate-hint {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.gate-hint__text {
    font-size: 12px;
    font-weight: 600;
}
</style>
